import React from 'react';
import { Icon } from '../../Icons';
import { Ripple } from '../../Ripple';

interface MailToProps {
  mail: string;
  subject: string;
  message: string;
}
interface Props {
  mailTo: MailToProps;
}
export const EmailShared = ({ mailTo }: Props) => {
  const { mail, message, subject } = mailTo;
  const config = `mailto:${mail || ''}?subject=${subject}&body=${message}`;
  return (
    <Ripple>
      <li className="pt16 pb16 b--alto bb pointer hover-bg-wild-sand">
        <a href={config} className="flex items-center f14 fw4 abbey no-underline" title="Email">
          <Icon name="SvgIconMail" className="mr4" height={24} width={24} customId="email-shared" />
          E-mail
        </a>
      </li>
    </Ripple>
  );
};
